<mat-card appearance="outlined">
  <mat-card-header>
    <div class="top-bar">
      <div class="top-bar__title">
        {{ 'INBOX.SETTINGS.PREVIEW.TITLE' | translate }}
      </div>
      <div class="top-bar__actions">
        <mat-icon>more_vert</mat-icon>
      </div>
    </div>
    <div *ngIf="showAvailabilityMessage">
      <glxy-alert class="top-bar__alert" type="tip" size="large" [borderRadius]="false">
        {{ availabilityMessage }}
      </glxy-alert>
    </div>
  </mat-card-header>
  <mat-card-content>
    <glxy-chat-container>
      <glxy-chat-bubble type="received" messageFrom="A" [messageText]="fakeText"></glxy-chat-bubble>

      <glxy-chat-bubble type="received" messageFrom="A" [messageText]="fakeText"></glxy-chat-bubble>

      <glxy-chat-bubble
        type="sent"
        messageFrom="B"
        [sentFromYou]="true"
        [messageText]="fakeText"
        [showProfilePic]="true"
      ></glxy-chat-bubble>

      <glxy-chat-bubble type="received" messageFrom="A" [messageText]="fakeText"></glxy-chat-bubble>
    </glxy-chat-container>
  </mat-card-content>
</mat-card>
